<!-- 签约详情 -->
<template>
  <div class="app-container" v-loading="loading">
    <el-tabs v-model="activeTab">
      <!-- 基础信息 -->
      <el-tab-pane label="基础信息" name="basic">
        <!-- 签约信息 -->
        <el-descriptions title="签约信息" :column="3">
          <el-descriptions-item label="签约编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.signId }}</el-descriptions-item>
          <el-descriptions-item label="签约公司" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ getCompanyName(signInfo.signCompanyName) }}</el-descriptions-item>
          <el-descriptions-item label="签约状态" :labelStyle="labelStyle" :contentStyle="contentStyle">
            {{ getStatusLabel(String(signInfo.status)) }}
          </el-descriptions-item>
          <el-descriptions-item label="签约年份" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.signYear }}</el-descriptions-item>
          <el-descriptions-item label="签约时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ formatDateTime(signInfo.signDate) }}</el-descriptions-item>
        </el-descriptions>

        <!-- 用户信息 -->
        <el-descriptions title="用户信息" :column="3" :style="{ 'margin-top': '12px' }">
          <el-descriptions-item label="用户姓名" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.userName }}</el-descriptions-item>
          <el-descriptions-item label="手机号" :labelStyle="labelStyle" :contentStyle="contentStyle">
            {{ signInfo.phone }}
            <span v-if="signInfo.phone">
              <img v-if="!dataVisible.phone" src="@/assets/eye-close.png" @click="toggleVisibility('phone')" />
              <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('phone')" />
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="身份证号" :labelStyle="labelStyle" :contentStyle="contentStyle">
            {{ signInfo.idCard }}
            <span v-if="signInfo.idCard">
              <img v-if="!dataVisible.idCard" src="@/assets/eye-close.png" @click="toggleVisibility('idCard')" />
              <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('idCard')" />
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="家庭地址" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.homeAddress }}</el-descriptions-item>
          <el-descriptions-item label="银行卡号" :labelStyle="labelStyle" :contentStyle="contentStyle">
            {{ signInfo.bankAccount }}
            <span v-if="signInfo.bankAccount">
              <img v-if="!dataVisible.bankAccount" src="@/assets/eye-close.png" @click="toggleVisibility('bankAccount')" />
              <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('bankAccount')" />
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="银行编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.bankCode }}</el-descriptions-item>
          <el-descriptions-item label="银行名称" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ signInfo.bankName }}{{ signInfo.subBankName }}</el-descriptions-item>
        </el-descriptions>

        <!-- 附件列表 -->
        <el-descriptions title="附件列表" :style="{ 'margin-top': '12px' }"></el-descriptions>
        <div class="image-container" v-if="annexList.length > 0">
          <div v-for="(item, index) in annexList" :key="index" class="image-item">
            <template v-if="isDocFile(item.annexId) && item.annexType != 102">
              <div class="doc-container">
                <el-link type="primary" @click="downloadFile(item.annexId)" class="doc-link">
                  {{ getFileName(item.annexId) }}
                </el-link>
              </div>
            </template>
            <template v-else-if="item.annexType === 102">
              <div class="doc-container">
                <el-link type="primary" @click="downloadFile(item.annexId)" class="doc-link">
                  {{ getFileName(item.annexId) }}
                </el-link>
              </div>
              <div class="image-label">证明文件(JPG/PDF/Word)</div>
            </template>
            <template v-else-if="item.annexType === 103">
              <div class="video-item" @click="handleVideoPreview(item.annexId)">
                <div class="video-cover">
                  <i class="el-icon-video-play"></i>
                  <span>视频</span>
                </div>
              </div>
              <div class="image-label">认证视频</div>
            </template>
            <template v-else>
              <image-upload class="img-box" :editMode="false" :imageUrl.sync="item.annexId" />
            </template>
            <div class="image-label">{{ annexTypeOptions[index] || '' }}</div>
          </div>
        </div>
        <div v-else class="no-data">暂无附件</div>

        <!-- 操作日志 -->
        <el-descriptions title="操作日志" :style="{ 'margin-top': '12px' }"></el-descriptions>
        <el-table :data="logList" border style="width: 100%; margin-bottom: 20px;">
          <el-table-column label="序号" type="index" min-width="100"></el-table-column>
          <el-table-column label="操作时间" prop="createdDate" min-width="180">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createdDate) }}
            </template>
          </el-table-column>
          <el-table-column label="操作节点" prop="nodeName" min-width="100"></el-table-column>
          <el-table-column label="操作人" prop="operator" min-width="120"></el-table-column>
          <el-table-column label="当前状态" prop="signStatus" min-width="150">
            <template slot-scope="scope">
              {{ getStatusLabel(String(scope.row.signStatus)) }}
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 合同 -->
      <el-tab-pane label="合同" name="contract">
        <div v-if="signInfo.docNo" class="contract-preview" v-loading="contractLoading" element-loading-text="合同加载中...">
          <iframe v-if="contractPdfUrl" :src="contractPdfUrl" class="contract-iframe" frameborder="0"></iframe>
          <div v-if="!contractPdfUrl && !contractLoading" class="no-data">合同加载失败</div>
        </div>
        <div v-else class="no-data">暂无合同数据</div>
      </el-tab-pane>
    </el-tabs>

    <!-- 返回按钮 -->
    <div style="text-align: center; margin-top: 20px;">
      <el-button @click="$router.back(-1)">返回</el-button>
      <el-button v-if="canReview" type="danger" @click="handleReject">驳回修改</el-button>
      <el-button v-if="canReview" type="success" @click="handleApprove">审核通过</el-button>
    </div>

    <!-- 视频预览对话框 -->
    <el-dialog title="视频预览" :visible.sync="videoDialogVisible" width="800px" :before-close="handleCloseVideo">
      <div class="video-player-container">
        <video v-if="currentVideoUrl" :src="currentVideoUrl" controls autoplay style="width: 100%; height: 100%;">
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>

    <!-- 驳回弹窗 -->
    <el-dialog title="驳回修改" :visible.sync="rejectDialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules">
        <el-form-item label="驳回意见" prop="approvalRemark">
          <el-input v-model="rejectForm.approvalRemark" type="textarea" :rows="4" placeholder="请输入驳回意见（最多100字）" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button :loading="rejectLoading" @click="confirmReject">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getSignDetail, approveSign, rejectSign, approveByLegal, rejectByLegal, downloadContractByDocNo } from '@/api/invoiceManagement'
import imageUpload from '@/components/Upload/ImageUpload'
import dayjs from 'dayjs'
import enumMixin from '@/views/COldForNewService/enumMixin.js'

export default {
  name: 'SignDetail',
  components: {
    imageUpload
  },
  mixins: [enumMixin],
  computed: {
    baseUrl() {
      return process.env.BASE_API
    },
    // 是否有审核权限
    canReview() {
      const { status } = this.signInfo
      const roleId = this.$store.getters.roleId
      return (status === 104 && [1,3,5].includes(roleId)) || (status === 105 && roleId === 12)
    }
  },
  data() {
    return {
      labelStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#9d9d9d'
      },
      contentStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#333',
        'word-break': 'break-all',
        'word-wrap': 'break-word'
      },
      loading: false,
      activeTab: 'basic',
      signId: '',
      signInfo: {},
      annexList: [],
      logList: [],
      // 附件类型枚举
      annexTypeOptions: ['身份证人像面', '身份证国徽面', '手持身份证', '银行卡正面', '银行卡反面'],
      // 脱敏数据相关
      originSignInfo: {},
      dataVisible: {
        phone: false,
        idCard: false,
        bankAccount: false
      },
      phone: '',
      idCard: '',
      bankAccount: '',
      // 视频预览相关
      videoDialogVisible: false,
      currentVideoUrl: '',
      // 合同PDF预览相关
      contractPdfUrl: '',
      contractLoading: false,
      contractLoaded: false,
      // 驳回弹窗相关
      rejectDialogVisible: false,
      rejectLoading: false,
      rejectForm: {
        approvalRemark: ''
      },
      rejectRules: {
        approvalRemark: [
          { required: true, message: '请输入驳回意见', trigger: 'blur' },
          { max: 100, message: '驳回意见最多100个字符', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.signId = this.$route.query.signId
    if (this.signId) {
      this.getDetail()
    }
  },
  beforeDestroy() {
    // 释放blob URL，防止内存泄漏
    if (this.contractPdfUrl) {
      URL.revokeObjectURL(this.contractPdfUrl)
    }
  },
  watch: {
    activeTab(newTab) {
      if (newTab === 'contract' && this.signInfo.docNo && !this.contractLoaded) {
        this.loadContractPdf()
      }
    }
  },
  methods: {
    // 获取详情数据
    async getDetail() {
      this.loading = true
      try {
        const res = await getSignDetail(this.signId)
        if (res.statusCode === 200 && res.data) {
          this.signInfo = res.data.invoiceSign || {}
          this.originSignInfo = this.signInfo ? { ...this.signInfo } : {}
          // 过滤掉 annexType 为 104 的数据
          this.annexList = (res.data.annexList || []).filter(item => item.annexType !== 104)
          this.logList = res.data.invoiceSignLogList || []

          // 处理脱敏数据
          if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
            const phoneMappings = {
              phone_phone: 'phone',
              idCard_idCard: 'idCard',
              bankCode_bankCard: 'bankAccount'
            }
            res.data.desensitizationDtoList.forEach(item => {
              const targetProperty = phoneMappings[item.sensitizationCode]
              if (targetProperty) {
                this[targetProperty] = {
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                }
              }
            })
          }
        } else {
          this.$message.error(res.message || '获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败', error)
        this.$message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    // 加载合同PDF
    async loadContractPdf() {
      if (!this.signInfo.docNo) return
      this.contractLoading = true
      try {
        const res = await downloadContractByDocNo(this.signInfo.docNo)
        // 接口返回blob数据，创建blob URL用于预览
        const blob = res instanceof Blob ? res : new Blob([res], { type: 'application/pdf' })
        this.contractPdfUrl = URL.createObjectURL(blob)
        this.contractLoaded = true
      } catch (error) {
        console.error('加载合同失败', error)
        this.$message.error('加载合同失败')
      } finally {
        this.contractLoading = false
      }
    },
    // 审核通过
    async handleApprove() {
      try {
        await this.$confirm('确认审核通过吗？', '提示', {
          type: 'warning'
        })
        let res
        if (this.signInfo.status === 105) {
          // 法务审批签约
          res = await approveByLegal({ signId: this.signId })
        } else {
          // 普通审核签约
          res = await approveSign({ signId: this.signId })
        }
        if (res.statusCode === 200) {
          this.$message.success('审核通过')
          this.getDetail()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('审核失败', error)
          this.$message.error('操作失败')
        }
      }
    },
    // 驳回修改
    handleReject() {
      this.rejectForm.approvalRemark = ''
      this.rejectDialogVisible = true
      this.$nextTick(() => {
        this.$refs.rejectForm && this.$refs.rejectForm.clearValidate()
      })
    },
    // 确认驳回
    async confirmReject() {
      try {
        await this.$refs.rejectForm.validate()
        this.rejectLoading = true
        let res
        if (this.signInfo.status === 103) {
          // 法务拒绝签约
          res = await rejectByLegal({ signId: this.signId, approvalRemark: this.rejectForm.approvalRemark.trim() })
        } else {
          // 普通拒绝签约
          res = await rejectSign({ signId: this.signId, approvalRemark: this.rejectForm.approvalRemark.trim() })
        }
        if (res.statusCode === 200) {
          this.$message.success('已驳回')
          this.rejectDialogVisible = false
          this.getDetail()
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('驳回失败', error)
          this.$message.error('操作失败')
        }
      } finally {
        this.rejectLoading = false
      }
    },
    // 获取公司名称
    getCompanyName(code) {
      const companyMap = {
        ZH: '珠海',
        CS: '长沙',
        WH: '芜湖',
        SJZ: '石家庄',
        TJ: '天津',
        ZZ: '郑州'
      }
      return companyMap[code] || code
    },
    // 获取状态标签
    getStatusLabel(status) {
      const option = this.InvoiceSignStatusEnum.find(item => item.enumCode === status)
      return option ? option.description : ''
    },
    // 时间格式化
    formatDateTime(time) {
      if (!time) return ''
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    },
    // 判断是否为doc/docx文件
    isDocFile(annexId) {
      if (!annexId) return false
      const lowerAnnexId = annexId.toLowerCase()
      return lowerAnnexId.endsWith('.doc') || lowerAnnexId.endsWith('.docx') || lowerAnnexId.endsWith('.pdf')
    },
    // 获取文件名
    getFileName(annexId) {
      if (!annexId) return '--'
      const parts = annexId.split('/')
      return parts[parts.length - 1] || annexId
    },
    // 下载文件
    downloadFile(annexId) {
      const url = `${this.baseUrl}/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${annexId}`
      window.open(url, '_blank')
    },
    // 视频预览
    handleVideoPreview(videoUrl) {
      if (videoUrl) {
        videoUrl = process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${videoUrl}`
        this.currentVideoUrl = videoUrl
        this.videoDialogVisible = true
      }
    },
    // 关闭视频对话框
    handleCloseVideo(done) {
      this.currentVideoUrl = ''
      this.videoDialogVisible = false
    },
    // 获取明文数据
    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    // 切换数据显示状态
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'phone':
          if (this.dataVisible.phone && this.phone.message) {
            this.getSourceOrigin(this.phone).then(res => {
              this.$set(this.signInfo, 'phone', res)
            })
          } else if (!this.dataVisible.phone) {
            // 还原为原始脱敏数据
            this.$set(this.signInfo, 'phone', this.originSignInfo.phone)
          }
          break
        case 'idCard':
          if (this.dataVisible.idCard && this.idCard.message) {
            this.getSourceOrigin(this.idCard).then(res => {
              this.$set(this.signInfo, 'idCard', res)
            })
          } else if (!this.dataVisible.idCard) {
            // 还原为原始脱敏数据
            this.$set(this.signInfo, 'idCard', this.originSignInfo.idCard)
          }
          break
        case 'bankAccount':
          if (this.dataVisible.bankAccount && this.bankAccount.message) {
            this.getSourceOrigin(this.bankAccount).then(res => {
              this.$set(this.signInfo, 'bankAccount', res)
            })
          } else if (!this.dataVisible.bankAccount) {
            // 还原为原始脱敏数据
            this.$set(this.signInfo, 'bankAccount', this.originSignInfo.bankAccount)
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 100px;
  margin-bottom: 20px;
}

.img-box {
  width: 120px;
  height: 120px;
}

.image-item {
  display: flex;
  flex-direction: column;
}

.image-label {
  font-size: 12px;
  color: #909399;
}

.no-data {
  width: 100%;
  text-align: center;
  padding: 20px;
  color: #909399;
  font-size: 14px;
}

.doc-container {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.doc-link {
  color: #00b882;
  font-size: 12px;
  word-break: break-all;
  line-height: 1.4;
  padding: 8px;
  text-align: center;
}

.video-item {
  width: 120px;
  height: 120px;
  cursor: pointer;

  .video-cover {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #fff;
    color: #909399;

    i {
      font-size: 30px;
      margin-bottom: 4px;
    }

    span {
      font-size: 12px;
    }
  }

  &:hover .video-cover {
    background: #fff;
    color: #409eff;
  }
}

.video-player-container {
  width: 100%;
  height: 450px;
  background: #000;
  border-radius: 4px;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

// 脱敏数据眼睛图标样式
::v-deep .el-descriptions-item__content {
  img {
    width: 16px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
    margin-left: 5px;
  }
}

.dialog-footer {
    padding: 20px;
  box-sizing: border-box;
}

.contract-preview {
  width: 100%;
  min-height: 600px;
}

.contract-iframe {
  width: 100%;
  height: 700px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/contractManagement/detail.vue